






























































































































import 'reflect-metadata'
import { Component, Vue } from 'vue-property-decorator'
import { InspectionApi } from "@/api"

@Component
export default class DialogInspection extends Vue { 
    dialog = false
    itemsPerPage = 4
    items = [
        { 
            unitId: "",
            transferPlanType:"",
            inspectionDateAfterTransfer:"",
            pjDateAfterTransfer:"",
            letterPlanforCR:"",
            crNote:"",
            pjNote:"",
        }
    ] as any[]
    loadding = false
    headers = [
				{ text: "ประเภทการเข้าตรวจ", value: "unitCode", width: 150, sortable: false },
				{ text: "วันที่ CR ระบุในจดหมายเชิญตรวจ(กรณีเข้าตรวจหลังโอน)", value: "addressNo", width: 150 ,sortable: false },
				{ text: "วันที่ PJ Plan แล้วเสร็จ(กรณีเข้าตรวจหลังโอน)", value: "addressNo", width: 150 ,sortable: false },
				{ text: "วันที่ PJ Plan ให้ลูกค้าเข้าตรวจเพื่อระบุในจดหมายนัดตรวจ", value: "addressNo", width: 150 ,sortable: false },

				{ text: "Plan PJ พร้อมให้เข้าตรวจ #1", value: "addressNo", width: 150 ,sortable: false },
				{ text: "วันเก็บงานเสร็จพร้อมตรวจ #1", value: "addressNo", width: 150 ,sortable: false },
				{ text: "วันที่ CR นัดได้ #1", value: "addressNo", width: 150 ,sortable: false },
				{ text: "เวลาที่ CR นัดได้ #1", value: "addressNo", width: 150 ,sortable: false },
				{ text: "วันที่ลูกค้าเข้าตรวจจริง #1", value: "addressNo", width: 150 ,sortable: false },
				{ text: "สถานะการรับมอบ #1", value: "addressNo", width: 150 ,sortable: false },

                { text: "Plan PJ พร้อมให้เข้าตรวจ #2", value: "addressNo", width: 150 ,sortable: false },
				{ text: "วันเก็บงานเสร็จพร้อมตรวจ #2", value: "addressNo", width: 150 ,sortable: false },
				{ text: "วันที่ CR นัดได้ #2", value: "addressNo", width: 150 ,sortable: false },
				{ text: "เวลาที่ CR นัดได้ #2", value: "addressNo", width: 150 ,sortable: false },
				{ text: "วันที่ลูกค้าเข้าตรวจจริง #2", value: "addressNo", width: 150 ,sortable: false },
                { text: "สถานะการรับมอบ #2", value: "addressNo", width: 150 ,sortable: false },

                { text: "Plan PJ พร้อมให้เข้าตรวจ #3", value: "addressNo", width: 150 ,sortable: false },
				{ text: "วันเก็บงานเสร็จพร้อมตรวจ #3", value: "addressNo", width: 150 ,sortable: false },
				{ text: "วันที่ CR นัดได้ #3", value: "addressNo", width: 150 ,sortable: false },
				{ text: "เวลาที่ CR นัดได้ #3", value: "addressNo", width: 150 ,sortable: false },
				{ text: "วันที่ลูกค้าเข้าตรวจจริง #3", value: "addressNo", width: 150 ,sortable: false },
                { text: "สถานะการรับมอบ #3", value: "addressNo", width: 150 ,sortable: false },

                { text: "Plan PJ พร้อมให้เข้าตรวจ #4", value: "addressNo", width: 150 ,sortable: false },
				{ text: "วันเก็บงานเสร็จพร้อมตรวจ #4", value: "addressNo", width: 150 ,sortable: false },
				{ text: "วันที่ CR นัดได้ #4", value: "addressNo", width: 150 ,sortable: false },
				{ text: "เวลาที่ CR นัดได้ #4", value: "addressNo", width: 150 ,sortable: false },
				{ text: "วันที่ลูกค้าเข้าตรวจจริง #4", value: "addressNo", width: 150 ,sortable: false },
                { text: "สถานะการรับมอบ #4", value: "addressNo", width: 150 ,sortable: false },
    ]

    async openDialog (unitId: number) {
        this.dialog = true
        const inspectionData: InspectionApi.IGetInspectionByUnitId[] = await InspectionApi.GetInspectionByUnitId(unitId)
        const inspectionList = [
            { 
                unitId: inspectionData[0].unitId,
                unitCode: inspectionData[0].unitCode,
                transferPlanType: inspectionData[0].transferPlanType,
                inspectionDateAfterTransfer: inspectionData[0].inspectionDateAfterTransfer,
                pjDateAfterTransfer: inspectionData[0].pjDateAfterTransfer,
                letterPlanforCR: inspectionData[0].letterPlanforCR,
                crNote: inspectionData[0].crNote,
                pjNote: inspectionData[0].pjNote,
                headers: "เข้าตรวจ 1",
                inspectionId: inspectionData[0].inspection1Id,
                inspectionPlanPJDate: inspectionData[0].inspection1PlanPJDate === "" ? "-" : inspectionData[0].inspection1PlanPJDate,
                inspectionFinishPJDate: inspectionData[0].inspection1FinishPJDate === "" ? "-" : inspectionData[0].inspection1FinishPJDate,
                inspectionPlanCRDate: inspectionData[0].inspection1PlanCRDate === "" ? "-" : inspectionData[0].inspection1PlanCRDate,
                inspectionPlanCRTime: inspectionData[0].inspection1PlanCRTime === "" ? "-" : inspectionData[0].inspection1PlanCRTime,
                inspectionCusDate: inspectionData[0].inspection1CusDate === "" ? "-" : inspectionData[0].inspection1CusDate,
                inspectionTypeId: inspectionData[0].inspection1TypeId === 0 ? "-" : inspectionData[0].inspection1TypeId,
                inspectionTypeText: inspectionData[0].inspection1TypeText === "" ? "-" : inspectionData[0].inspection1TypeText,
            },
            { 
                headers: "เข้าตรวจ 2",
                inspectionId: inspectionData[0].inspection2Id,
                inspectionPlanPJDate: inspectionData[0].inspection2PlanPJDate === "" ? "-" : inspectionData[0].inspection2PlanPJDate,
                inspectionFinishPJDate: inspectionData[0].inspection2FinishPJDate === "" ? "-" : inspectionData[0].inspection2FinishPJDate,
                inspectionPlanCRDate: inspectionData[0].inspection2PlanCRDate === "" ? "-" : inspectionData[0].inspection2PlanCRDate,
                inspectionPlanCRTime: inspectionData[0].inspection2PlanCRTime === "" ? "-" : inspectionData[0].inspection2PlanCRTime,
                inspectionCusDate: inspectionData[0].inspection2CusDate === "" ? "-" : inspectionData[0].inspection2CusDate,
                inspectionTypeId: inspectionData[0].inspection2TypeId === 0 ? "-" : inspectionData[0].inspection2TypeId,
                inspectionTypeText: inspectionData[0].inspection2TypeText === "" ? "-" : inspectionData[0].inspection2TypeText,
            },
            { 
                headers: "เข้าตรวจ 3",
                inspectionId: inspectionData[0].inspection3Id,
                inspectionPlanPJDate: inspectionData[0].inspection3PlanPJDate === "" ? "-" : inspectionData[0].inspection3PlanPJDate,
                inspectionFinishPJDate: inspectionData[0].inspection3FinishPJDate === "" ? "-" : inspectionData[0].inspection3FinishPJDate,
                inspectionPlanCRDate: inspectionData[0].inspection3PlanCRDate === "" ? "-" : inspectionData[0].inspection3PlanCRDate,
                inspectionPlanCRTime: inspectionData[0].inspection3PlanCRTime === "" ? "-" : inspectionData[0].inspection3PlanCRTime,
                inspectionCusDate: inspectionData[0].inspection3CusDate === "" ? "-" : inspectionData[0].inspection3CusDate,
                inspectionTypeId: inspectionData[0].inspection3TypeId === 0 ? "-" : inspectionData[0].inspection3TypeId,
                inspectionTypeText: inspectionData[0].inspection3TypeText === "" ? "-" : inspectionData[0].inspection3TypeText,
            },
            { 
                headers: "เข้าตรวจ 4",
                inspectionId: inspectionData[0].inspection4Id,
                inspectionPlanPJDate: inspectionData[0].inspection4PlanPJDate === "" ? "-" : inspectionData[0].inspection4PlanPJDate,
                inspectionFinishPJDate: inspectionData[0].inspection4FinishPJDate === "" ? "-" : inspectionData[0].inspection4FinishPJDate,
                inspectionPlanCRDate: inspectionData[0].inspection4PlanCRDate === "" ? "-" : inspectionData[0].inspection4PlanCRDate,
                inspectionPlanCRTime: inspectionData[0].inspection4PlanCRTime === "" ? "-" : inspectionData[0].inspection4PlanCRTime,
                inspectionCusDate: inspectionData[0].inspection4CusDate === "" ? "-" : inspectionData[0].inspection4CusDate,
                inspectionTypeId: inspectionData[0].inspection4TypeId === 0 ? "-" : inspectionData[0].inspection4TypeId,
                inspectionTypeText: inspectionData[0].inspection4TypeText === "" ? "-" : inspectionData[0].inspection4TypeText,
            }
        ]

        this.items = inspectionList
    }
}
